import { render, staticRenderFns } from "./TutorialPlayer.vue?vue&type=template&id=723e0070&scoped=true"
import script from "./TutorialPlayer.vue?vue&type=script&lang=js"
export * from "./TutorialPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e0070",
  null
  
)

export default component.exports